import { find } from "lodash";
import { AICC_SANDBOX_LESSON } from "constants/aiccPromptSandbox";
import { AiccReviewScript, AiccReviewScriptLine } from "types/model/aiccLearningAssets";
import { AiccSandboxCursor } from "types/model/aiccPromptSandbox";

// 🔴 From the cursor forward: it can sit on the other role's line, as production's `_resolve_learner_idx` handles.
export const learnerLineAt = (script: AiccReviewScript, lineIdx: number): AiccReviewScriptLine | undefined =>
  find(script.lines, ({ speaker }, index) => index >= lineIdx && speaker === AICC_SANDBOX_LESSON.learnerSpeaker);

// 🔴 Filled in here because /action is stateless. An empty `user_text` is valid: the prompt hints from the cue alone.
export const lessonHintVariables = (
  script: AiccReviewScript | undefined,
  cursor: AiccSandboxCursor | undefined,
  lastAnswer: string | undefined
) => {
  const line = script && cursor ? learnerLineAt(script, cursor.lineIdx) : undefined;

  if (!line) {
    return undefined;
  }

  return {
    cue_en: line.cue,
    expected: line.text,
    user_text: (cursor?.retryCount ? lastAnswer : "") ?? "",
  };
};
